<template>
  <div class="card card-custom">
    <div class="card-header">
      <h3 class="card-title">List</h3>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Category</label>
            <select class="form-control" v-model="categoryID">
              <option value="0" selected="selected">All</option>
              <option v-for="item in category" v-bind:value="item.ResourceCategoryID">{{item.Name}}</option>
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>Course</label>
            <select class="form-control" v-model="courseID">
              <option value="0" selected="selected">All</option>
              <option v-for="item in courses" v-bind:value="item.CourseID">{{item.CourseName}}</option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <br />
            <button type="button" v-on:click="loadResources()" class="btn btn-sm btn-primary">Load Resources</button>
          </div>
        </div>
      </div>
      <div class="row" v-if="record.length > 0">
        <div class="col-md-12">
          <form>
            <table class="table table-sm table-bordered" id="tbl">
              <thead class="bg-custom">
                <tr>
                  <th style="width: 10px">Sr.</th>
                  <th style="width: 18%">Category</th>
                  <th style="width: 18%">Class</th>
                  <th style="width: 18%">Course</th>
                  <th>File</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, masterInd) in record">
                  <td style="vertical-align: middle;">{{masterInd + 1}}</td>
                  <td> {{item.Category}} </td>
                  <td style="width: 20%"> {{item.Class}} </td>
                  <td> {{item.Course}} </td>
                  <td>
                    <!--<a :href="item.URL" download="item.Title">
                      <i v-if="item.FileType == '.pdf'" class="fa fa-file-pdf text-danger"></i>
                      <i v-else-if="item.FileType == '.zip'" class="fa fa-file-archive text-primary"></i>
                      <i v-else class="fas fa-file-image text-success"></i> {{item.Title}}{{item.FileType}}
                      <br />
                      <small class="text-right">added on: {{item.InsertedOn}} </small>
                    </a>-->
                    <button type="button" style="border: none; background: transparent;" v-on:click="download(item.URL, item.Title, item.FileType)">
                        <i v-if="item.FileType == '.pdf'" class="fa fa-file-pdf text-danger"></i>
                        <i v-else-if="item.FileType == '.zip'" class="fa fa-file-archive text-primary"></i>
                        <i v-else class="fas fa-file-image text-success"></i> {{item.Title}}{{item.FileType}}
                        <br />
                        <small class="text-right">added on: {{item.InsertedOn}} </small>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
  #file:hover {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    color: blue;
  }
</style>
<script>
  import axios from 'axios';
  export default ({

    data() {
      return {
        isupdate: false,
        category: [],
        courses: [],
        categoryID: 0,
        courseID: 0,
        dateFrom: "",
        dateTo: "",
        record: [],
      }
    },

    created: function () {
      this.pageLoad();
    },

    updated: function () {
      $('#tbl').DataTable();
    },

    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/PortalApi/pageLoadCurriculumResourcesList')
          .then(function (s) {
            endReq();
            //vm.classes = s.data.cls;
            vm.category = s.data.cat;
            vm.courses = s.data.allCourses;
            vm.loadResources();
          })
          .catch(function (s) {

          });
      },

      loadResources() {
        startReq();
        var vm = this;
        axios.post('/api/PortalApi/loadActiveResources?courseID=' + vm.courseID + "&catID=" + vm.categoryID + "&dateFrom=" + vm.dateFrom + "&dateTo=" + vm.dateTo)
          .then(function (s) {
            endReq();
            vm.record = s.data.lst;
          })
          .catch(function (s) {

          });
      },

      cancel() {
        window.location.reload();
      },

      download(url, title, type) {
        startReq()
        toastr.info("It may take some time, do not reload page");
        axios({
          url: url,
          method: 'GET',
          responseType: 'blob'
        })
          .then((response) => {
            if (response.status === 200) {
              const url =
                window.URL.createObjectURL
                  (new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', title + type);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
              endReq();
            } else {
              endReq();
              console.error('Error: Received non-200 status code');
            }
          })
          .catch((error) => {
            endReq();
            console.error('Error downloading the image:', error);
          }); 
      },

    },
  });</script>



// WEBPACK FOOTER //
// src/components/school/LMS/curriculumResources.vue